<script lang="ts">
  // Bloom's "2-sigma" diagram: two achievement distributions, the tutored one
  // shifted ~2 standard deviations to the right.
  let {
    conventional,
    withTane,
    axis,
  }: { conventional: string; withTane: string; axis: string } = $props();

  const base = 168;
  const amp = 120;
  const sig = 44;
  const meanA = 118; // conventional
  const meanB = 213; // tutored (~2σ to the right)

  function curve(mean: number): string {
    let d = `M 16 ${base}`;
    for (let x = 16; x <= 344; x += 3) {
      const y = base - amp * Math.exp(-((x - mean) ** 2) / (2 * sig * sig));
      d += ` L ${x} ${y.toFixed(1)}`;
    }
    return d + ` L 344 ${base} Z`;
  }
  const pathA = curve(meanA);
  const pathB = curve(meanB);
  const peak = base - amp;
</script>

<svg class="sigma" viewBox="0 0 360 210" role="img" aria-label="{conventional} vs {withTane}">
  <!-- baseline -->
  <line x1="12" y1={base} x2="348" y2={base} stroke="var(--line-strong)" stroke-width="1" />

  <!-- conventional -->
  <path d={pathA} fill="rgba(194,105,60,0.14)" stroke="var(--terra)" stroke-width="2" />
  <line x1={meanA} y1={base} x2={meanA} y2={peak + 6} stroke="var(--terra)" stroke-width="1" stroke-dasharray="3 3" opacity="0.7" />

  <!-- tutored / Tane -->
  <path d={pathB} fill="rgba(95,179,100,0.2)" stroke="var(--green)" stroke-width="2.4" />
  <line x1={meanB} y1={base} x2={meanB} y2={peak + 6} stroke="var(--green)" stroke-width="1" stroke-dasharray="3 3" opacity="0.7" />

  <!-- +2σ shift annotation -->
  <g>
    <line x1={meanA} y1={peak - 4} x2={meanB} y2={peak - 4} stroke="var(--ink-soft)" stroke-width="1" marker-end="url(#ah)" marker-start="url(#ah2)" />
    <rect x={(meanA + meanB) / 2 - 22} y={peak - 17} width="44" height="17" rx="8" fill="var(--ink)" />
    <text x={(meanA + meanB) / 2} y={peak - 5} text-anchor="middle" class="badge">+2σ</text>
  </g>

  <defs>
    <marker id="ah" markerWidth="7" markerHeight="7" refX="5" refY="3" orient="auto">
      <path d="M0 0L6 3L0 6z" fill="var(--ink-soft)" />
    </marker>
    <marker id="ah2" markerWidth="7" markerHeight="7" refX="1" refY="3" orient="auto">
      <path d="M6 0L0 3L6 6z" fill="var(--ink-soft)" />
    </marker>
  </defs>

  <!-- labels -->
  <text x={meanA} y={base + 16} text-anchor="middle" class="lab terra">{conventional}</text>
  <text x={meanB} y={base + 16} text-anchor="middle" class="lab green">{withTane}</text>
  <text x="180" y={base + 34} text-anchor="middle" class="axis">{axis} →</text>
</svg>

<style>
  .sigma {
    width: 100%;
    height: auto;
    overflow: visible;
  }
  .lab {
    font-family: var(--font-sans);
    font-size: 11px;
    font-weight: 700;
  }
  .lab.terra {
    fill: var(--terra-deep);
  }
  .lab.green {
    fill: var(--green-deep);
  }
  .axis {
    font-family: var(--font-mono);
    font-size: 9px;
    letter-spacing: 0.08em;
    fill: var(--muted);
  }
  .badge {
    font-family: var(--font-mono);
    font-size: 10px;
    font-weight: 700;
    fill: var(--paper);
  }
</style>
